/**
 * Tipos de evento — copiados do select do cadastro de evento (CadastroEvento.js ~1323), que é
 * onde o `evento.tipo` é gravado.
 *
 * O casamento do SLA é igualdade estrita de string (`s.tipo IN ('todos', e.tipo)`), então campo
 * livre aqui produzia SLA que casa com ZERO eventos por causa de um typo, sem erro nenhum. Lista
 * fechada é o que impede isso.
 *
 * `congressonacional` e `congressointernacional` estão COMENTADOS no CadastroEvento — não dá mais
 * para criar evento com eles. Ficam aqui mesmo assim porque o SLA casa com o que já existe, e há
 * evento antigo em produção com esses tipos; sem eles, esse evento não seria alcançável por nenhum
 * SLA específico.
 *
 * Mantenha em sincronia com o CadastroEvento: tipo que existir lá e faltar aqui vira evento que
 * nenhum SLA alcança.
 */
export const TIPOS_EVENTO = [
    { value: 'todos', label: 'Todos' },
    { value: 'advisoryboard', label: 'Advisory Board' },
    { value: 'congresso', label: 'Congresso' },
    { value: 'congressonacional', label: 'Congresso Nacional' },
    { value: 'congressointernacional', label: 'Congresso Internacional' },
    { value: 'congestadcotapat', label: 'Congresso - Estande e/ou Cota de Patrocínio' },
    { value: 'convencaonacional', label: 'Convenção' },
    { value: 'convencaointernacional', label: 'Convenção Internacional' },
    { value: 'estandecotapat', label: 'Estande e/ou Cota de Patrocínio' },
    { value: 'estcotpatsimpsanoeveterc', label: 'Estande e/ou Cota de Patrocínio - Simpósio Sanofi em Evento de Terceiro' },
    { value: 'estcotpatcongsimpsanoeveterc', label: 'Estande e/ou Cota de Patrocínio - Congresso - Simpósio Sanofi em Evento de Terceiro' },
    { value: 'eventoexclusivo', label: 'Evento Exclusivo' },
    { value: 'eventointerno', label: 'Evento Interno' },
    { value: 'eventoterceiros', label: 'Evento de Terceiros' },
    { value: 'minimeet', label: 'Mini Meeting' },
    { value: 'orgsede', label: 'Organizado Pela Sede' },
    { value: 'reuniaotreinamento', label: 'Reunião de Treinamento' },
    { value: 'scieneducpromee', label: 'Scientific Educational Program/Meeting' },
    { value: 'simposio', label: 'Simpósio' },
    { value: 'simpsanofeventerc', label: 'Simpósio Sanofi em Evento de Terceiro' },
    { value: 'speakmeet', label: 'Speaker Meeting (One-Time)' },
    { value: 'webmeeting', label: 'Web Meeting' },
];

/**
 * Rótulo de cliente no mesmo formato do cadastro de evento: código, nome, município/UF, documento
 * e nome fantasia. Só o nome não basta — a base tem homônimos e filiais, e quem escolhe precisa do
 * código e da praça para saber qual é qual.
 */
export const rotuloCliente = (registro) => registro.codigo
    + ' - ' + registro.nome
    + (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '')
    + (registro.cnpj ? ' (' + registro.cnpj + ')' : '')
    + (registro.cpf ? ' (' + registro.cpf + ')' : '')
    + (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
